import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function NavButReels( props ){
    //console.debug("RTS Break NavButReels");

    const history = useNavigate();
    const {user, sessionCustomer, setCurFilter} = useSessionContext();

    function handleReelsClick(e) {
        setCurFilter(null);

        if(props.setOpenDrawerFx){
            props.setOpenDrawerFx(false);
        };

        let filterObj = {"user":user, 
        "status":[1,25,50],
        "customers":sessionCustomer.customer,
        "orders":[], 
        "projects":[], 
        "products":[], 
        "reelTypes":[],
        "reels":[],
        "lengthOperator":">=",
        "length":0,
        "namedLocations":[],
        "crews":[],
        "trackers":[],
        "shipDateOperator":">=",
        "shipDate":null,
        "pinned":-1,
        "locked":-1, 
        "daysStationaryOperator":">=",
        "daysStationary":0,
        "sortBy":0 
        };

        history("/LoadList", {state:{filter:filterObj}});        
    }


    if(sessionCustomer.accessLevel === 1 && sessionCustomer.fullAccess == 0){
        return("");
    }



    if(props.mode==="NavDrawer"){
        return (
            <>
            <ListItem button key="Reels" onClick={handleReelsClick} sx={{cursor:"pointer"}}>
                <ListItemText primary="Reels" />
            </ListItem>
            </>
        )
    }    


    return (
        <>
        <Button
            key='Reels'
            onClick={handleReelsClick}
            sx={{ my: 2, mx: 1, color: 'white', textTransform: 'unset' }}
        >
            Reels
        </Button>
        </>
    );
}



